module.exports = __webpack_public_path__ + "static/neutraldinosaurprint-bc8ffb1687119e39d0ff887d480dcb57.jpeg";